import { useEffect } from 'react';

function isSameOrigin(targetWindow: Window | null, currentWindow: Window | null = window) {
	let isSameOrigin;
	try {
		isSameOrigin = targetWindow?.location.origin === currentWindow?.location.origin;
	} catch (e) {
		// catch the DOM exception, mark the resolution to "false"
		isSameOrigin = false;
	}
	return isSameOrigin;
}

export const calculateDepth = (hostWindow: Window, offset = 0): number => {
	let currentWindow = hostWindow;
	let hostFrameOffset = 0;

	while (currentWindow && currentWindow !== window.top) {
		hostFrameOffset += 1;
		currentWindow = currentWindow.parent;
	}

	return hostFrameOffset - offset;
};

const attachHostOffsetOverride = (window: Window) => {
	if (window.top) {
		if (isSameOrigin(window.top)) {
			const containerDepth = calculateDepth(window);
			// @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
			window.top.getHostOffsetFunctionOverride = (hostWindow: Window) =>
				calculateDepth(hostWindow, containerDepth + 1);
		}
	}
};

const detachHostOffsetOverride = () => {
	if (window.top) {
		if (isSameOrigin(window.top)) {
			// @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
			delete window.top.getHostOffsetFunctionOverride;
		}
	}
};

export function useHostOffsetOverride(): void {
	useEffect(() => {
		attachHostOffsetOverride(window);
		return () => {
			detachHostOffsetOverride();
		};
	}, []);
}
